import enTranslations from '../locales/en.json';
import frTranslations from '../locales/fr.json';


type TranslationKey = string;
type Translations = typeof enTranslations;

// Default to English
let currentLanguage: 'en' | 'fr' = 'en';

const translations: Record<'en' | 'fr', Translations> = {
    en: enTranslations,
    fr: frTranslations,
};

export const setLanguage = (lang: 'en' | 'fr') => {
    currentLanguage = lang;
};

export const getLanguage = (): 'en' | 'fr' => {
    return currentLanguage;
};

const getNestedValue = (obj: Record<string, unknown>, path: string): string => {
    const keys = path.split('.');
    let value: unknown = obj;

    for (const key of keys) {
        if (value && typeof value === 'object' && key in value) {
            value = (value as Record<string, unknown>)[key];
        } else {
            return path;
        }
    }

    return typeof value === 'string' ? value : path;
};

// Module-level (not created inside useTranslation) so it has a stable identity across renders —
// it only reads the module-level `currentLanguage` at call time, so it never needs to be
// recreated. A fresh `t` on every render was breaking memoization (useCallback/useEffect deps)
// in every component that calls useTranslation(), causing render loops downstream.
const t = (key: TranslationKey): string => {
    const translation = translations[currentLanguage];
    return getNestedValue(translation, key);
};

// Same `t`, for non-component modules (e.g. shared copy objects) that can't call the hook.
export const translate = t;

export const useTranslation = () => {
    return { t, setLanguage, getLanguage };
};
